var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.004,
    height: 16.004,
    viewBox: "0 0 16.004 16.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8333",
    "data-name": "Caminho 8333",
    d: "M16.471,3.134H12.736V2.6a1.6,1.6,0,0,0-1.6-1.6H6.868a1.6,1.6,0,0,0-1.6,1.6v.533H1.533a.533.533,0,1,0,0,1.067h1.11l.864,10.357A2.683,2.683,0,0,0,6.165,17H11.84A2.683,2.683,0,0,0,14.5,14.558L15.361,4.2h1.11a.533.533,0,1,0,0-1.067ZM6.335,2.6a.533.533,0,0,1,.533-.533h4.268a.533.533,0,0,1,.533.533v.533H6.335Zm7.1,11.869a1.61,1.61,0,0,1-1.6,1.468H6.165a1.61,1.61,0,0,1-1.6-1.468L3.714,4.2H14.29Z",
    transform: "translate(-1 -1)",
    fill: "#38d2d9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8334",
    "data-name": "Caminho 8334",
    d: "M12.533,12a.533.533,0,0,0-.533.533v5.335a.533.533,0,0,0,1.067,0V12.533A.533.533,0,0,0,12.533,12Z",
    transform: "translate(-6.132 -6.132)",
    fill: "#38d2d9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8335",
    "data-name": "Caminho 8335",
    d: "M18.533,12a.533.533,0,0,0-.533.533v5.335a.533.533,0,0,0,1.067,0V12.533A.533.533,0,0,0,18.533,12Z",
    transform: "translate(-8.931 -6.132)",
    fill: "#38d2d9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.85c0b15cf6a02633913e93e2f87d5aef.svg";
export { ForwardRef as ReactComponent };